import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'account'})
export class AccountPipe implements PipeTransform {

    transform(value: string): string {

        if (!value) {
            return value;
        }

        return this.formatAccount(value);
    }

    formatAccount(account: string): string {
        const separator = ' ';
    
        return account.substring(0, 4).
                       concat(separator).concat(account.substring(4, 8)).
                       concat(separator).concat(account.substring(8, 12)).
                       concat(separator).concat(account.substring(12));
     }
}
